import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Typography, Menu, MenuItem, ListItemIcon, Fade } from "@material-ui/core";
import EditIcon from "@material-ui/icons/BorderColorTwoTone";
import RegisterPaymentIcon from "@material-ui/icons/CloudUploadTwoTone";
import DeleteIcon from "@material-ui/icons/DeleteTwoTone";
import VisibilityIcon from "@material-ui/icons/VisibilityTwoTone";

import translate from "../i18n/Translator";
import { Payment } from "../model/Payment";
import { AppContext } from "../context/AppContext";

interface PaymentMenuProps {
    payment: Payment;
    skipSee?: boolean;
    anchor: HTMLElement | null;
    onClose(): any;
    onComplete(): any;
    onRefresh(): any;
    onDelete(): any;
}

export default function PaymentMenu(props: PaymentMenuProps) {
    const context = useContext(AppContext);
    return (
        <Menu
            id="payments-item"
            anchorEl={props.anchor}
            keepMounted
            onClose={props.onClose}
            open
            TransitionComponent={Fade}
        >
            {context.isGrantedAny(["PaymentsRead", "CustomersPaymentsRead"]) && !props.skipSee &&
                <MenuItem button component={Link} to={`/payments/${props.payment.id}`} onClick={props.onClose} dense>
                    <ListItemIcon>
                        <VisibilityIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.see")}</Typography>
                </MenuItem>
            }
            {context.isGranted("CustomersPaymentsUpdate") && (props.payment.status === "NEW" || props.payment.status === "EXPIRED") &&
                <MenuItem button onClick={props.onRefresh} dense>
                    <ListItemIcon>
                        <EditIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.edit")}</Typography>
                </MenuItem>
            }
            {context.isGranted("CustomersPaymentsUpdate") && (props.payment.status === "NEW" || props.payment.status === "EXPIRED") &&
                <MenuItem button onClick={props.onComplete} dense>
                    <ListItemIcon>
                        <RegisterPaymentIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.complete_payment")}</Typography>
                </MenuItem>
            }
            {context.isGranted("CustomersPaymentsDelete") && (props.payment.status === "NEW" || props.payment.status === "EXPIRED") &&
                <MenuItem button onClick={props.onDelete} dense>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.delete")}</Typography>
                </MenuItem>
            }
        </Menu>
    );

}